import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { PlaylistEmbedUrl, ReleaseEmbedUrl } from '@soundxyz/utils/constants/embeds';

const prefetchStore: Record<string, true> = {};

export function usePrefetchEmbed({
  releaseId,
  playlistId,
}: {
  releaseId?: string | null | false;
  playlistId?: string | null | false;
}) {
  useEffect(() => {
    if (!releaseId || prefetchStore[releaseId]) return;

    prefetchStore[releaseId] = true;

    fetch(
      ReleaseEmbedUrl({
        releaseId,
      }),
      {
        method: 'GET',
        mode: 'cors',
      },
    ).catch(err => {
      Sentry.captureException(err, {
        level: 'warning',
      });
    });
  }, [releaseId]);

  useEffect(() => {
    if (!playlistId || prefetchStore[playlistId]) return;

    prefetchStore[playlistId] = true;

    Promise.all([
      fetch(
        PlaylistEmbedUrl({
          playlistId,
          theme: 'light',
        }),
        {
          method: 'GET',
          mode: 'cors',
        },
      ),
      fetch(
        PlaylistEmbedUrl({
          playlistId,
          theme: 'dark',
        }),
        {
          method: 'GET',
          mode: 'cors',
        },
      ),
    ]).catch(err => {
      Sentry.captureException(err, {
        level: 'warning',
      });
    });
  }, [playlistId]);
}
